import { Input } from 'antd'
import { faGraduationCap, faStethoscope, faTag } from '@fortawesome/pro-solid-svg-icons'

import { SectionGroupProperties } from '../../../utils/entities/sectionGroup'
import FormItem from '../../../Components/shared/Forms/FormItem'
import SectionsSelector from '../../../Components/shared/Selectors/SectionsSelector'
import SectorsSelector from '../../../Components/shared/Selectors/SectorsSelector'
import { getIdOrNull } from '../../../utils'
import { ColorsPalette } from '../../../config/colors'

const FIELD_WIDTH = '100%'
const FIELD_STYLE = { width: FIELD_WIDTH }
const FIELD_ERROR_STYLE = { ...FIELD_STYLE, border: `2px solid ${ColorsPalette.RED}`, borderRadius: '4px' }

const { NAME, SECTIONS, SECTORS } = SectionGroupProperties

const SectionGroupForm = ({ data, sectionsToHighlight, disabled, errorFields, onChange }) => {
  const handleOptionChange = key => (value, _, entity) => onChange(({ [key]: entity ?? value }))
  const handleEventChange = key => e => onChange(({ [key]: e.target.value }))

  const getFieldStyle = field => errorFields.includes(field) ? FIELD_ERROR_STYLE : FIELD_STYLE

  return (
    <div className='section-group-form pd-4 mb-8'>
      <FormItem icon={faTag} label='common.name' required>
        <Input
          style={getFieldStyle(NAME)}
          value={data[NAME]}
          onChange={handleEventChange(NAME)}
        />
      </FormItem>
      <FormItem icon={faGraduationCap} label='common.sections' required>
        <SectionsSelector
          values={data[SECTIONS].map(getIdOrNull)}
          style={getFieldStyle(SECTIONS)}
          disabled={disabled}
          onChange={handleOptionChange(SECTIONS)}
          highlightValues={sectionsToHighlight}
        />
      </FormItem>
      <FormItem icon={faStethoscope} label='common.sectors' required>
        <SectorsSelector
          placeholder='*'
          values={data[SECTORS].map(getIdOrNull)}
          style={getFieldStyle(SECTORS)}
          disabled={disabled}
          multiple='multiple'
          onChange={handleOptionChange(SECTORS)}
        />
      </FormItem>
    </div>
  )
}

export default SectionGroupForm
